import type { ReactElement } from "react"
import { useState } from "react"
import BaseContainer from "@gatsby-plugin-generic-page/components/BaseContainer"
import BaseSection from "@gatsby-plugin-generic-page/components/BaseSection"
import CtaElement from "@gatsby-plugin-generic-page/components/CtaElement"
import Header from "@gatsby-plugin-generic-page/components/Header"
import type { TabsUDSSectionFlatData } from "@gatsby-plugin-generic-page/fragments/tabsUDSSection"
import { GenericPageSectionsRenderer } from "@gatsby-plugin-generic-page/GenericPage"
import Tabs, {
  TabsList,
  TabsTrigger,
} from "@ionos-web-design-system/react/tabs"
import isEmpty from "~/lib/isEmpty"

export default function TabsUDSSection({
  header,
  tabs,
  ctaElement,
  sectionSettings,
}: TabsUDSSectionFlatData): ReactElement<TabsUDSSectionFlatData> {
  const tabsWithSection = tabs.filter((tab) => !isEmpty(tab.section))
  const [activeTab, setActiveTab] = useState<string>(
    tabsWithSection[0]?.label || ""
  )

  const activeSections =
    tabsWithSection.find((tab) => tab.label === activeTab)?.section ||
    tabsWithSection[0]?.section ||
    []

  return (
    <BaseSection {...sectionSettings}>
      <BaseContainer {...sectionSettings?.containerSettings}>
        {!isEmpty(header) ? (
          <div className="mb-7">
            <Header {...header} />
          </div>
        ) : null}

        {!isEmpty(tabsWithSection) ? (
          <Tabs
            value={activeTab}
            onValueChange={setActiveTab}
            orientation="horizontal"
          >
            <div className="overflow-x-auto overflow-y-hidden pb-2">
              <TabsList className="w-max">
                {tabsWithSection.map((tab) => (
                  <TabsTrigger
                    key={tab.label}
                    value={tab.label}
                    className="data-[state=active]:text-black!"
                  >
                    {tab.label}
                  </TabsTrigger>
                ))}
              </TabsList>
            </div>
          </Tabs>
        ) : null}

        <div className="-mx-3">
          <GenericPageSectionsRenderer
            pageId={activeTab}
            sections={activeSections}
          />
        </div>

        {!isEmpty(ctaElement) ? (
          <div className="flex justify-center pt-7">
            <CtaElement ctaElement={ctaElement} />
          </div>
        ) : null}
      </BaseContainer>
    </BaseSection>
  )
}
